// ErrorBoundary.jsx — app-wide safety net. Any uncaught render error shows a
// friendly reload screen instead of React's blank white page (which stranded
// mobile users after scanner crashes — see BarcodeScannerModal).
import { Component } from "react";

export default class ErrorBoundary extends Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("App crashed:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="crash-screen">
          <h2>Something went wrong</h2>
          <p>Sorry about that — tap below to reload the app.</p>
          <button onClick={() => window.location.reload()}>Reload</button>
        </div>
      );
    }
    return this.props.children;
  }
}
